module.exports = __webpack_public_path__ + "f218f5e3113df0db1f29e9678f3f3437.svg";